import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import resources from "../lang/resource.js";
import { getDomainConfig } from "../utils/domain";

// 根據 domain 獲取預設語言
const getDefaultLanguage = () => {
  try {
    const domainConfig = getDomainConfig();
    console.log('Domain config:', domainConfig); // 調試用
    return domainConfig.defaultLanguage || "zh-TW";
  } catch (error) {
    console.log('Error getting domain config, using fallback:', error);
    return "zh-TW";
  }
};

// 動態獲取初始語言
const getInitialLanguage = () => {
  // 如果 URL 中已經有語言參數，優先使用
  const pathLang = window.location.pathname.split('/')[1];
  const supportedLangs = ['zh-TW', 'en', 'ko', 'vi', 'ja'];
  
  if (supportedLangs.includes(pathLang)) {
    return pathLang;
  }
  
  // 否則根據 domain 返回預設語言
  return getDefaultLanguage();
};

i18n
  .use(LanguageDetector) //偵測瀏覽器語言
  .use(initReactI18next)
  .init({
    lng: getInitialLanguage(),  //動態獲取初始語言
    fallbackLng: "zh-TW", // 若當前語言沒有對應的翻譯則使用這個語言
    resources, //引入字典檔
    interpolation: {
      // 是否要讓字詞 escaped 來防止 xss 攻擊，因為 React.js 已經做了，這裡設成 false
      escapeValue: false,
    },
  });

export default i18n;